import {
  Col,
  DesignTokens,
  EditIcon,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Title,
} from "melco-ui";
import { LicensesHistoryList } from "./LicensesHistoryList";
import { FormattedDate } from "../table/FormattedDate";
import { useTranslation } from "react-i18next";
import { MelcoModelsUserSerialNumber } from "melco-shared-logic";
import { ResendEmailButton } from "./ResendEmailButton";
import { useGenericDrawer } from "../../hooks/drawer/useGenericDrawer";
import { EditEmailDrawer } from "./drawer/editemail/EditEmailDrawer";
import { isEmpty } from "lodash-es";
const { spacings } = DesignTokens;

export interface DisplayLicenseDetailsProps {
  license: MelcoModelsUserSerialNumber | undefined;
  onCloseDrawerCallBackFn?: () => void;
}

export const DisplayLicenseDetails: React.FC<DisplayLicenseDetailsProps> = ({
  license,
  onCloseDrawerCallBackFn,
}) => {
  /**
       * License Status
         0-NotActivated
         1-Activated
         2-Cancelled
       */

  const { t } = useTranslation();
  const {
    batch,
    referral,
    master_name,
    master_user_name,
    product_name,
    type,
    product_version_number,
    product_level_name,
    serial_number,
    updated_date,
    assigned_name,
    assigned_user_name,
    created_date,
    bridge_email_address,
  } = license || {};

  const emailIdToResendEmail =
    master_user_name && master_user_name.trim() !== ""
      ? master_user_name
      : bridge_email_address;

  const editEmailDrawerRef = useGenericDrawer();
  const { isDrawerOpen, openDrawer } = editEmailDrawerRef;
  return (
    <>
      {
        <FullWidthSpace direction="vertical" size="large">
          <div>
            <Title level={4}>
              {t("licenses.basic.detail.form.title.licenseDetails")}
            </Title>

            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={6}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licenses.basic.detail.form.label.product_name")}
                    content={product_name ?? ""}
                    fallback={t("global.fallback.empty")}
                  />

                  <LabeledItem
                    label={t(
                      "licenses.basic.detail.form.label.product_version_number"
                    )}
                    content={product_version_number ?? ""}
                    fallback={t("global.fallback.empty")}
                  />

                  <LabeledItem
                    label={t(
                      "licenses.basic.detail.form.label.product_level_name"
                    )}
                    content={product_level_name ?? ""}
                    fallback={t("global.fallback.empty")}
                  />
                </Space>
              </Col>
              <Col xs={24} md={6}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licenses.basic.detail.form.label.serial_number")}
                    content={serial_number ?? ""}
                    fallback={t("global.fallback.empty")}
                  />

                  <LabeledItem
                    label={t("licenses.basic.detail.form.label.batch")}
                    content={batch ?? ""}
                    fallback={t("global.fallback.empty")}
                  />

                  <LabeledItem
                    label={t("licenses.basic.detail.form.label.refferal")}
                    content={referral}
                    fallback={t("global.fallback.empty")}
                  />

                  <LabeledItem
                    label={t("licenses.basic.detail.form.label.status")}
                    content={t(`licenses.basic.status_type.${type}` as any)}
                    fallback={t("global.fallback.empty")}
                  />
                </Space>
              </Col>
              <Col xs={24} md={6}>
                <Space direction="vertical" size="middle">
                  {/* <LabeledItem
                                        label={t("licenses.basic.detail.form.label.created_from")}
                                        content={created_by}
                                        fallback={t("global.fallback.empty")}
                                    />
                             */}

                  <LabeledItem
                    label={t("licenses.basic.detail.form.label.created_at")}
                    content={<FormattedDate date={created_date} />}
                    //content=""
                    fallback={t("global.fallback.empty")}
                  />

                  {updated_date ? (
                    <LabeledItem
                      label={t(
                        "licenses.basic.detail.form.label.last_modified"
                      )}
                      content={<FormattedDate date={updated_date} />}
                      fallback={t("global.fallback.empty")}

                      //   content=""
                    />
                  ) : (
                    <LabeledItem
                      label={t(
                        "licenses.basic.detail.form.label.last_modified"
                      )}
                      content={""}
                      fallback={t("global.fallback.empty")}
                    />
                  )}

                  {master_user_name && master_user_name?.trim() !== "" ? (
                    <>
                      <LabeledItem
                        label="Email"
                        content={emailIdToResendEmail}
                        fallback={t("global.fallback.empty")}
                      />
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col xs={24} md={23}>
                          <LabeledItem
                            label="Email"
                            content={emailIdToResendEmail}
                            fallback={t("global.fallback.empty")}
                          />
                        </Col>
                        <Col xs={24} md={1}>
                          {/* <Button >Edit</Button> */}
                          {/**
                           * Email field  that can be edited
                           * the condition would be
                           * type 0 and bridge_email_address field
                           * value not empty
                           */}
                          {type === 0 && !isEmpty(bridge_email_address) && (
                            <EditIcon
                              style={{ fontSize: "18px" }}
                              onClick={() => openDrawer()}
                            />
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                  <ResendEmailButton serial_number={serial_number ?? ""} />
                </Space>
              </Col>
              <Col xs={24} md={6}>
                <Space direction="vertical" size="middle">
                  {(master_user_name && master_user_name?.trim() !== "") ||
                  (master_name && master_name?.trim() !== "") ? (
                    <LabeledItem
                      label={t("licenses.basic.detail.form.label.owner")}
                      content={
                        <>
                          <Row>{master_user_name}</Row>
                          <Row>{master_name}</Row>
                        </>
                      }
                      fallback={t("global.fallback.empty")}
                    />
                  ) : (
                    <LabeledItem
                      label={t("licenses.basic.detail.form.label.owner")}
                      content={""}
                      fallback={t("global.fallback.empty")}
                    />
                  )}

                  {(assigned_user_name && assigned_user_name?.trim() !== "") ||
                  (assigned_name && assigned_name?.trim() !== "") ? (
                    <LabeledItem
                      label={t(
                        "licenses.basic.detail.form.label.assigned_user"
                      )}
                      content={
                        <>
                          <Row>{assigned_user_name}</Row>
                          <Row>{assigned_name}</Row>
                        </>
                      }
                      fallback={t("global.fallback.empty")}
                    />
                  ) : (
                    <LabeledItem
                      label={t(
                        "licenses.basic.detail.form.label.assigned_user"
                      )}
                      content={""}
                      fallback={t("global.fallback.empty")}
                    />
                  )}
                </Space>
              </Col>
            </Row>
          </div>

          <div>
            <Title level={4}>
              {t("licenses.basic.detail.form.title.history")}
            </Title>

            {license && <LicensesHistoryList license={license} />}
          </div>
        </FullWidthSpace>
      }

      {isDrawerOpen && (
        <EditEmailDrawer
          drawerRef={editEmailDrawerRef}
          email_address={emailIdToResendEmail ?? ""}
          serial_number={serial_number ?? ""}
          onCloseDrawerCallback={onCloseDrawerCallBackFn}
        />
      )}
    </>
  );
};
